/**
 * Menu location slugs passed to GraphQL as MenuLocationEnum.
 * Must match the enum values in your WordPress WPGraphQL schema (from register_nav_menus).
 * Override via env if your theme uses different names.
 *
 * Default footer is PRIMARY so the build succeeds when WordPress has no FOOTER in MenuLocationEnum.
 * Set NEXT_PUBLIC_MENU_LOCATION_FOOTER to your theme's footer location (e.g. FOOTER, FOOTER_MENU) if registered.
 */
export const PRIMARY_LOCATION =
  process.env.NEXT_PUBLIC_MENU_LOCATION_PRIMARY ?? 'PRIMARY';
export const FOOTER_LOCATION =
  process.env.NEXT_PUBLIC_MENU_LOCATION_FOOTER ?? 'PRIMARY';
